import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectUsersSlide, setSelectedUser, toggleUserSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { updateUser } from '../../store/slices/api/inner/userlistSlice';
import Select from '../common/Select';

const UsersForm = ({
    defaultData,
    fetchData,
}) => {
    const UsersIsOpen = useSelector(selectUsersSlide);
    const dispatch = useDispatch();

    const memberShipOptions = [
        { value: "7 Day Trial" },
        { value: "30 Days Premium Membership" },
    ]

    const defaultValues = {
        nextBillingDate: defaultData?.next_billing_date ?? "",
        activatedPlan: defaultData?.activated_plan ?? "",
    }

    const afterAPICall = (response) => {
        fetchData()
        dispatch(toggleUserSlide())
        dispatch(setSelectedUser(null))
    }

    const beforeAPICall = (data) => {
        return {
            success: true,
            refactoredData: {
                query: {
                    usersId: defaultData?.user_id ?? "",
                },
                formData: {
                    ...data,
                }
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateUser : () => { },
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            const formattedDate = defaultData?.next_billing_date?.split('T')[0];

            setValue('nextBillingDate', formattedDate);
            setValue('activatedPlan', defaultData.activated_plan);
        } else {
            setValue('nextBillingDate', "")
            setValue('activatedPlan', "")
        }
    }, [defaultData, setValue]);

    return (
        <SlideOver isOpen={UsersIsOpen} toggleOpen={toggleUserSlide} panelName={defaultData ? "Update User" : ""}>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    type='date'
                    name="nextBillingDate"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Next Billing Date"
                />
                <Select
                    control={control}
                    name="activatedPlan"
                    rules={{ required: "this field is required" }}
                    options={memberShipOptions}
                    label="Activated Plan"
                />

                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default UsersForm